var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompany = function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.583,
    d: "M18.943 19.082V6.415l-6.846-2.2L5.096 6.5l.13 12.582z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.188,
    d: "M10.907 9.64h2.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.188,
    d: "M10.116 19.083V13.54h3.959v5.543"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.583,
    d: "M19.032 11.165h3.959v7.917h-3.959M5.158 11.165H1.199v7.917h3.959"
  })));
};
export default SvgCompany;